module.exports = __webpack_public_path__ + "static/media/27459220_1966554416941654_7752688022149705483_n.60c692c9.jpg";